import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { WithIntlProps } from 'react-intl';

export const ThemePopupMenu: LoadableType<
	WithIntlProps<{
		intl: any;
		isOpen: any;
		trigger: any;
		onSelected: any;
		closeMenu: any;
	}>
> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ThemePopupMenu" */ '../src/ThemePopupMenu/ThemePopupMenu.tsx'
			)
		).ThemePopupMenu,
});
